import { getApiErrorKeys, getApiErrorMessage } from "./apiErrors";
import { PHONE_ERRORS } from "./phone";

// French messages for the self-service phone/email change (SFAPI-207). The API
// returns translation keys (in `detail`, or as violation messages); their
// French text is in the shared map (`src/lib/apiErrorMessages.ts`), with the
// phone-format wording of the user forms on top (SFRESTO-172).

export const UNKNOWN_ERROR = "Une erreur inconnue est survenue";

/** French text for a failed profile save, code request or code check. */
export function identifierChangeErrorMessage(error: unknown): string {
  return getApiErrorMessage(error, UNKNOWN_ERROR, { messages: PHONE_ERRORS });
}

// After these errors the API has cancelled the pending change: the code dialog
// must close and the user starts over.
const GONE_KEYS = [
  "identifier_change.code_expired",
  "identifier_change.too_many_attempts",
  "identifier_change.none_pending",
  "validation.user.error.phone.exists",
  "validation.user.error.email.exists",
];

export function isPendingChangeGone(error: unknown): boolean {
  return getApiErrorKeys(error).some((key) =>
    GONE_KEYS.some((gone) => key.includes(gone))
  );
}
